import { render, staticRenderFns } from "./culturalStation.vue?vue&type=template&id=29677ac8&scoped=true&"
import script from "./culturalStation.vue?vue&type=script&lang=js&"
export * from "./culturalStation.vue?vue&type=script&lang=js&"
import style0 from "./culturalStation.vue?vue&type=style&index=0&id=29677ac8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29677ac8",
  null
  
)

export default component.exports